import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { type ReactElement, useEffect } from 'react';
import { useGroupAdminAccess } from '~/hooks/useIsGroupAdmin';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/admin',
)({
  component: GroupAdminLayout,
});

/**
 * The guard for every `/admin/*` screen.
 *
 * As in legacy, only group admins and platform admins get through; anyone else
 * is sent to the group root. It navigates from the component because the answer
 * depends on `getGroupBySlug`.
 */
function GroupAdminLayout(): ReactElement | null {
  const { groupName } = Route.useParams();
  const navigate = useNavigate();
  const { isGroupAdmin, isResolved } = useGroupAdminAccess();
  const refused = isResolved && !isGroupAdmin;

  useEffect(() => {
    if (refused) {
      navigate({
        to: '/groups/$groupName/',
        params: { groupName },
        replace: true,
      });
    }
  }, [refused, groupName, navigate]);

  if (refused) return null;

  return <Outlet />;
}
